/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Arraytype1Inputs */

const en__field_arraytype1 = /** @type {(inputs: _Field_Arraytype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is array token`)
};

/** @type {(inputs: _Field_Arraytype1Inputs) => LocalizedString} */
const de__field_arraytype1 = en__field_arraytype1;

/**
* | output |
* | --- |
* | "Is array token" |
*
* @param {_Field_Arraytype1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_arraytype1 = /** @type {((inputs?: _Field_Arraytype1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Arraytype1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_arraytype1(inputs)
	return de__field_arraytype1(inputs)
});
export { _field_arraytype1 as "_field_arrayType" }